import type { SearchWith } from '@scayle/storefront-nuxt'

export const DEBOUNCED_SEARCH_DURATION = 200 // in milliseconds
export const MIN_CHARS_FOR_SEARCH = 3
export const PRODUCT_LIMIT = 3
export const CATEGORY_LIMIT = 3

export const EXCLUDED_FROM_SEARCH_ATTRIBUTE_KEY = 'isExcludedFromSearch'
export const EXCLUDED_FROM_SEARCH_VALUE_ID = 686931

export const DIRECT_ORDER_ATTRIBUTE_KEY = 'directOrder'
// Value *ID* of `directOrder = ja` (single-select attribute, group id 1078,
// values ja/nein). Single source of truth for both the server-side `attributes:not`
// exclusion and the client-side `isDirectOrder` guard — both match the attribute
// value *ID*, mirroring `EXCLUDED_FROM_SEARCH_VALUE_ID` / `isExcludedFromSearch`.
// SAPI `whitelistAttributes` only matches IDs, not slugs — verified live
// (2026-06-16, shop 10001):
//   GET /v1/attributes/directOrder -> { ja: 201810, nein: 145753 }
//   /products?filters[directOrder]=201810 -> 293 hits; ...=ja (slug) -> 0 hits
export const DIRECT_ORDER_YES_VALUE_ID = 201810

// ECOM-2639: shared SAPI `whitelistAttributes` (`attributes:not`) entry that excludes
// direct-order products server-side. Applied to every Scayle PLP/search-suggestion
// request that must hide them (product listing, search-suggestion products, and the
// PLP filter/facet requests) so pagination totals and facet counts stay consistent
// with the rendered product set.
export const DIRECT_ORDER_EXCLUDE_FILTER = {
  type: 'attributes:not' as const,
  key: DIRECT_ORDER_ATTRIBUTE_KEY,
  values: [DIRECT_ORDER_YES_VALUE_ID],
}

export const SEARCH_WITH_PARAMS: SearchWith = {
  products: {
    attributes: {
      // ECOM-2639: `directOrder` is needed so suggestion products can be
      // excluded by the client-side isDirectOrder guard.
      withKey: ['color', 'brand', 'name', DIRECT_ORDER_ATTRIBUTE_KEY],
    },
    priceRange: true,
    categories: 'all',
    lowestPriorPrice: true,
  },
  categories: {
    parents: 'all',
    children: 10,
  },
}
